import {
  FileProtectOutlined,
  TeamOutlined,
  SolutionOutlined,
  FileDoneOutlined,
  EditOutlined,
  LineChartOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  ShoppingOutlined,
  AlertOutlined,
  MailOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const contractsSidebar: SidebarConfig = {
  module: 'contracts',
  titleKey: 'common:nav.contracts',
  icon: <FileProtectOutlined />,
  sections: [
    {
      key: 'contracts',
      labelKey: 'contracts:sidebar.sections.contracts',
      items: [
        { key: 'clients', path: '/contracts/clients', labelKey: 'contracts:pages.client', icon: <TeamOutlined /> },
        { key: 'subcontracts', path: '/contracts/subcontracts', labelKey: 'contracts:pages.subcontracts', icon: <SolutionOutlined /> },
      ],
    },
    {
      key: 'billing',
      labelKey: 'contracts:sidebar.sections.billing',
      items: [
        { key: 'ipc', path: '/contracts/ipc', labelKey: 'contracts:pages.ipc', icon: <FileDoneOutlined /> },
        { key: 'variation-orders', path: '/contracts/variation-orders', labelKey: 'contracts:pages.vo', icon: <EditOutlined /> },
        { key: 'profitability', path: '/contracts/profitability', labelKey: 'contracts:pages.profitability', icon: <LineChartOutlined /> },
      ],
    },
    {
      key: 'procurement',
      labelKey: 'contracts:sidebar.sections.procurement',
      items: [
        { key: 'rfq', path: '/contracts/rfq', labelKey: 'contracts:pages.rfq', icon: <ShoppingCartOutlined /> },
        { key: 'rfp', path: '/contracts/rfp', labelKey: 'contracts:pages.rfp', icon: <FileTextOutlined /> },
        { key: 'po', path: '/contracts/po', labelKey: 'contracts:pages.po', icon: <ShoppingOutlined /> },
      ],
    },
    {
      key: 'commercial',
      labelKey: 'contracts:sidebar.sections.commercial',
      items: [
        { key: 'claims', path: '/contracts/claims', labelKey: 'contracts:pages.claims', icon: <AlertOutlined /> },
        { key: 'correspondence', path: '/contracts/correspondence', labelKey: 'contracts:pages.correspondence', icon: <MailOutlined /> },
        { key: 'tender-pipeline', path: '/contracts/tender-pipeline', labelKey: 'contracts:pages.tenderPipeline', icon: <TrophyOutlined /> },
      ],
    },
  ],
};
